import React, { Component } from 'react'
import getLabel from '../../utilities/label.js'
import { Link } from 'react-router-dom'

export default class PeerToPeerRow extends Component {
  constructor(props) {
    super(props)
  }


  buttonTextTop(session) {
    if(session.one_on_one_wizard_is_complete) {
      return getLabel('reg_label_on')
    } else {
      return <br/>
    }
  }

  buttonIcon(session) {
    if(session.one_on_one_wizard_is_complete) {
      return <i className="fa fa-check-circle p2p-session-row" aria-hidden="true"></i>
    } else {
      return <i className="fa fa-plus-circle p2p-session-row" aria-hidden="true"></i>
    }
  }

  buttonTextBottom(session) {
    if(session.one_on_one_wizard_is_complete) {
      return getLabel('reg_label_schedule')
    }
  }

  tealText(session) {
    if(session.registration_required && session.registration_status !== 'not_authorized') {
      return 'teal'
    } else {
      return ''
    }
  }

  getP2POptIn(session) {
    const optIn = session.has_1_on_1_platform_opt_in
    if (optIn == false) {
      return 'false'
    } else {
      return 'true'
    }
  }

  render() {
    const session = this.props.session
    const tealText = this.tealText(session)
    const trackColor = session.track_color ? session.track_color : '#f2f2f2'
    return (
      <div key={session.id} >
        <div className='container'>
          <div className='row session'>
            <button
              className='session-reg'
              style={{ color: '#606060' }}
              disabled
            >
              <p className={'buttonTopText ' + tealText}>{this.buttonTextTop(session)}</p>
              {this.buttonIcon(this.props.session)}
              <p className={'buttonBottomText ' + tealText}>{this.buttonTextBottom(session)}</p>
            </button>
            <div className='track-color' style={{ backgroundColor: trackColor }}></div>
            <Link className='session-link' key={session.id} to={'/session/' + session.id}>
              <p className='session-name'>{session.name} </p>
              <p className='session-room'>{this.props.session.room_name}</p>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
